import "./newMember.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { DriveFolderUploadOutlined as UploadIcon } from "@mui/icons-material";
import {
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";

const NewMember = ({ inputs, title }) => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate(); // Initialize navigate

  const { state } = useLocation(); // Access state passed from navigate
  const memberData = state?.member || {}; // Extract member data or use an empty object

  // populate formData with memberData if editing
  const [formData, setFormData] = useState({
    userId: memberData.userId || userIdRedux,
    fullName: memberData.fullName || "",
    profession: memberData.profession || "",
    phoneNumber: memberData.phoneNumber || "",
    email: memberData.email || "",
    address: memberData.address || "",
    position: memberData.position || "",
    role: memberData.role || "ADD NEWS",
    status: memberData.status || "ACTIVE",
    password: "",
    memberImage: memberData.image || "",
  });

  const [memberImage, setMemberImage] = useState(memberData.image || "");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [backEndError, setBackEndError] = useState("");

  const validateForm = () => {
    const errors = {};

    if (!formData.fullName) errors.fullName = "Full Name is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.fullName))
    //   errors.fullName = "Full Name name must be a string.";
    if (!formData.profession) errors.profession = "Profession is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.profession))
    //   errors.profession = "Profession name must be a string.";
    if (!formData.phoneNumber) errors.phoneNumber = "Phone number is required.";
    if (!/^\d{10}$/.test(formData.phoneNumber))
      errors.phoneNumber = "Phone number must be 10 digits.";
    if (!formData.email) errors.email = "Email is required.";
    if (!/\S+@\S+\.\S+/.test(formData.email))
      errors.email = "Email format is invalid.";

    if (!formData.address) errors.address = "Address is required.";
    if (!formData.position) errors.position = "Position is required.";
    // if (!/^[a-zA-Z\s]+$/.test(formData.position))
    //   errors.position = "Position must be a string.";
    if (!formData.status) errors.status = "Member Status is required.";
    if (!formData.role) errors.role = "Member Role is required.";

    // Password validation
    if (!formData.password) errors.password = "Password is required.";
    // Example: Password should be at least 8 characters long
    if (formData.password && formData.password.length < 8)
      errors.password = "Password must be at least 8 characters long.";

    if (memberImage.length === 0)
      errors.memberImage = "Please select single image to be uploaded.";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setMemberImage(file);
      setFormData({ ...formData, memberImage: file });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setBackEndError("");
    const formDataToSubmit = new FormData();

    formDataToSubmit.append("userId", formData.userId);
    formDataToSubmit.append("fullName", formData.fullName);
    formDataToSubmit.append("profession", formData.profession);
    formDataToSubmit.append("phoneNumber", formData.phoneNumber);
    formDataToSubmit.append("email", formData.email);
    formDataToSubmit.append("address", formData.address);
    formDataToSubmit.append("position", formData.position);
    formDataToSubmit.append("role", formData.role);
    formDataToSubmit.append("status", formData.status);
    formDataToSubmit.append("password", formData.password);
    if (memberImage) formDataToSubmit.append("memberImage", memberImage);

    /**
     *
     * choosing URL whether to update or add member
     *
     */
    const MAIN_URL = memberData._id
      ? `${BASE_URL}/api/member/updateMember/${memberData._id}`
      : `${BASE_URL}/api/member/addMember`;

    let response = "";
    try {
      if (memberData._id) {
        response = await axios.put(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        response = await axios.post(MAIN_URL, formDataToSubmit, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (response.status === 201) {
        setBackEndError(<font color="green">Success TO ADD DATA.</font>);
        navigate("/members");
      } else if (response.status === 200) {
        setBackEndError(<font color="green">Success TO UPDATE DATA.</font>);
        navigate("/members");
      } else if (response.status === 401) {
        //alert or show error message
        setBackEndError(<font color="red">USER ALREADY EXISTS.</font>);
      } else if (response.status === 400) {
        //alert or show error message
        setBackEndError(<font color="red">ALL THE FIELDS ARE REQUIRED.</font>);
      } else if (response.status === 402) {
        //alert or show error message
        setBackEndError(<font color="red">INVALID USER DATA.</font>);
      }
    } catch (error) {
      const errorMessage = error.response.data.msg;
      setBackEndError(<span style={{ color: "red" }}>{errorMessage}</span>);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <form
            onSubmit={handleSubmit}
            style={{
              display: "grid",
              gap: "1rem",
              width: "100%",
            }}
          >
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="fullName"
                label="Full Name"
                type="text"
                value={formData.fullName}
                onChange={handleChange}
                error={Boolean(errors.fullName)}
                helperText={errors.fullName}
                fullWidth
                margin="normal"
                required
              />
              <TextField
                style={{ flex: 3 }}
                name="profession"
                label="Profession"
                type="text"
                value={formData.profession}
                onChange={handleChange}
                error={Boolean(errors.profession)}
                helperText={errors.profession}
                fullWidth
                margin="normal"
                required
              />

              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="phoneNumber"
                label="Phone Number"
                type="number"
                value={formData.phoneNumber}
                onChange={handleChange}
                error={Boolean(errors.phoneNumber)}
                helperText={errors.phoneNumber}
                fullWidth
                margin="normal"
                required
              />
              {/* Another TextField or empty space for 1/4 size */}
              <TextField
                style={{ flex: 3 }}
                name="email"
                label="Email"
                type="text"
                value={formData.email}
                onChange={handleChange}
                error={Boolean(errors.email)}
                helperText={errors.email}
                fullWidth
                margin="normal"
                required
              />
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="address"
                label="Address"
                type="text"
                value={formData.address}
                onChange={handleChange}
                error={Boolean(errors.address)}
                helperText={errors.address}
                fullWidth
                margin="normal"
                required
              />

              <TextField
                style={{ flex: 3 }}
                name="position"
                label="Position"
                type="text"
                value={formData.position}
                onChange={handleChange}
                error={Boolean(errors.position)}
                helperText={errors.position}
                fullWidth
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <FormControl
                style={{ flex: 3 }}
                margin="normal"
                error={Boolean(errors.role)}
              >
                <InputLabel>Role</InputLabel>
                <Select
                  name="role"
                  value={formData.role}
                  onChange={handleChange}
                >
                  <MenuItem value="ADD NEWS">ADD NEWS</MenuItem>
                  <MenuItem value="ADD HOME">ADD HOME</MenuItem>
                  <MenuItem value="ADD EVENTS">ADD EVENTS</MenuItem>
                  <MenuItem value="GENERATE REPORTS">GENERATE REPORTS</MenuItem>
                </Select>
                {errors.role && <FormHelperText>{errors.role}</FormHelperText>}
              </FormControl>
              <FormControl
                style={{ flex: 3 }}
                margin="normal"
                error={Boolean(errors.status)}
              >
                <InputLabel>Status</InputLabel>
                <Select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                >
                  <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                  <MenuItem value="RETIRE">RETIRE</MenuItem>
                </Select>
                {errors.status && (
                  <FormHelperText>{errors.status}</FormHelperText>
                )}
              </FormControl>
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 6 }}></label>
            </div>
            <div style={{ display: "flex", gap: "16px" }}>
              <TextField
                style={{ flex: 3 }}
                name="password"
                label="Password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                error={Boolean(errors.password)}
                helperText={errors.password}
                fullWidth
                margin="normal"
                required
              />
              {/* this label is only for occupy some spaces */}
              <label style={{ visibility: "hidden", flex: 9 }}></label>
            </div>

            <div style={{ display: "flex", gap: "16px" }}>
              <Button
                variant="outlined"
                component="label"
                startIcon={<UploadIcon />}
                style={{ margin: "10px 0" }}
              >
                Upload Image
                <input
                  id="image"
                  name="image"
                  type="file"
                  multiple
                  hidden
                  accept="image/*"
                  onChange={handleFileChange}
                />
              </Button>
            </div>
            {errors.memberImage && (
              <span className="error-message">{errors.memberImage}</span>
            )}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {memberImage && (
                <img
                  src={
                    memberImage instanceof File
                      ? URL.createObjectURL(memberImage)
                      : memberImage // Use existing URL if it's a string
                  }
                  alt="Preview"
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              )}
            </div>

            <span className="error-message">{backEndError}</span>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ borderRadius: "15px", width: "50%" }}
              disabled={loading}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" /> // Show loading spinner
              ) : (
                "Save"
              )}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewMember;
